import { Controller } from "@hotwired/stimulus"

// Toggles selected styling on each mode card based on its radio button state.
export default class extends Controller {
  static targets = ['card', 'step2Line', 'step3']

  connect() {
    this.update()
  }

  update() {
    let detailedModeSelected = false

    this.cardTargets.forEach((card) => {
      const radio = card.querySelector("input[type='radio']")
      const diagram = card.querySelector('.diagram')
      const checked = !!radio?.checked

      if (checked && radio?.value === 'detailed') {
        detailedModeSelected = true
      }

      card.classList.toggle('border-sky-400', radio?.checked)
      card.classList.toggle('ring-1', radio?.checked)
      card.classList.toggle('ring-sky-200', radio?.checked)

      if (diagram) {
        diagram.classList.toggle('hidden', !checked)
      }
    })

    if (this.hasStep3Target) {
      this.step3Target.classList.toggle('hidden', detailedModeSelected)
    }

    if (this.hasStep2LineTarget) {
      this.step2LineTarget.classList.toggle('hidden', detailedModeSelected)
    }
  }
}